import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserBaseComponent } from '@luggagehero/features/user';
@Component({
  selector: 'lh-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserComponent extends UserBaseComponent implements OnInit {}
